import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=a71aa92c&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./InstagramFeed.vue?vue&type=style&index=0&id=a71aa92c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a71aa92c",
  "72ee658f"
  
)

export default component.exports